// Shared timestamp utility for MAT feature (HHmmss with YYYYMMDD prefix)
export function matTimestamp(now: Date = new Date()): string {
  const d = now;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}-${pad(d.getHours())}${pad(
    d.getMinutes()
  )}${pad(d.getSeconds())}`;
}

export default matTimestamp;
